var script_loaded = false;

function loadJSscripts() {
  if (!script_loaded) {
    script_loaded = true;

    var scripts = document.getElementsByTagName("script");
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].getAttribute("data-src") !== null) {
        scripts[i].setAttribute("src", scripts[i].getAttribute("data-src"));
        delete scripts[i].dataset.src;
      }
    }

    var links = document.getElementsByTagName("link");
    for (var j = 0; j < links.length; j++) {
      if (links[j].getAttribute("data-href") !== null) {
        links[j].setAttribute("href", links[j].getAttribute("data-href"));
        delete links[j].dataset.href;
      }
    }

    document.dispatchEvent(new CustomEvent("StartKernelLoading"));

    setTimeout(function() {
      document.dispatchEvent(new CustomEvent("StartAsyncLoading"));
    }, (window.Shopify && window.Shopify.designMode) ? 10 : 400);
  }
}

if (window.Shopify && window.Shopify.designMode) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadJSscripts);
  } else {
    loadJSscripts();
  }
} else {
  if (window.addEventListener) {
    window.addEventListener("load", function() {
      setTimeout(loadJSscripts, 1200);
    }, false);
  } else if (window.attachEvent) {
    window.attachEvent("onload", function() {
      setTimeout(loadJSscripts, 1200);
    });
  } else {
    window.onload = function() {
      setTimeout(loadJSscripts, 1200);
    };
  }
}
